import React from 'react';
import { useParams } from 'react-router-dom';
import { UserProfileContainer } from './profile/UserProfileContainer';

export function UserProfile() {
  const { id } = useParams();
  return <UserProfileContainer userId={id!} />;
}
